<label class="type--{{model.required ? 'required' : 'optional'}} {{ model.checked && highlightOnChecked ? 'highlight-text' : 'normal-text'}}">
  <div class="app-checkbox">
    <input type="checkbox" [(ngModel)]="model.checked" labelPosition="before" (change)="onChange()">
    <span class="inner"></span>
  </div>
  <span [innerHtml]='model.label'></span>
</label>
